export default __webpack_public_path__ + "static/media/oldtv.bab3bd6c.png";